import { render, staticRenderFns } from "./AdvertisingTableItem.vue?vue&type=template&id=670ff48a&scoped=true"
import script from "./AdvertisingTableItem.vue?vue&type=script&lang=js"
export * from "./AdvertisingTableItem.vue?vue&type=script&lang=js"
import style0 from "./AdvertisingTableItem.vue?vue&type=style&index=0&id=670ff48a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670ff48a",
  null
  
)

export default component.exports